<ng-container *ngVar="extenededCompanies$ | async as allCompanies">
  @if (allCompanies?.length) {
    <span class="text-3xl font-bold text-navy-90">
      {{ buildTranslationKey('companyCount') | translate: { count: allCompanies?.length || 0 } }}
    </span>
    <div class="h-full flex flex-col">
      <app-header-data-sort
        class="w-full columns-wrapper border border-solid border-navy-40 rounded-t-md"
        [data]="extenededCompanies$ | async"
        [liveSort]="true"
        [sortDefinitions]="sortDefinitions"
        [startSortById]="'creation-time'"
        [selectedOrderBy]="startOrderBy"
        [changeQueryParams]="false"
        (sort)="handleSort($event)"
      ></app-header-data-sort>

      @if (sortedData$ | async; as sortedData) {
        <app-virtual-scroll-renderer-v2
          class="h-full overflow-y-auto no-scrollbar"
          [items]="sortedData"
          [virtualScrollBuffer]="1"
          [idSelector]="idSelector"
        >
          <ng-template #itemTemplate let-company="item">
            <app-company-item [companyId]="company.id" [userCount]="company.userCount"></app-company-item>
          </ng-template>
        </app-virtual-scroll-renderer-v2>
      }
    </div>
  } @else if ((hasCompanies$ | async) === false) {
    <div class="flex flex-col w-full gap-4 items-center h-full justify-center">
      <svg-icon [src]="'access-requests-empty-state'"></svg-icon>
      <div class="flex flex-col gap-2 justify-center items-center">
        <div class="text-navy-90 font-bold text-4xl">
          {{ buildTranslationKey('companies.emptyState.title') | translate }}
        </div>
        <div class="text-navy-70 text-base text-center">
          {{ buildTranslationKey('companies.emptyState.youCan') | translate }}
          <span class="cursor-pointer underline" (click)="openAddCompanyModal()">
            {{ buildTranslationKey('companies.emptyState.createCompany') | translate }}
          </span>
          {{ buildTranslationKey('companies.emptyState.for') | translate }}
        </div>
      </div>
    </div>
  } @else if (allCompanies.length === 0 && (hasCompanies$ | async)) {
    <div class="flex w-full gap-4 items-center h-full justify-center text-navy-90 text-3xl">
      {{ buildTranslationKey('companies.emptyState.emptySearch') | translate }}
    </div>
  }
</ng-container>
